import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { getTimestampFromString } from 'Helpers/DateTime';
import DatePicker from 'Components/Ant/DatePicker';

import NormalizedInput from '..';

import './index.css';

class DateInput extends Component {
  static get DEFAULT_MODE() {
    return 'date';
  }

  constructor(props) {
    super(props);

    const mode = props.mode || DateInput.DEFAULT_MODE;
    this.state = {
      mode,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleOpenChange = this.handleOpenChange.bind(this);
    this.handlePanelChange = this.handlePanelChange.bind(this);
  }

  handleChange(value) {
    const { name, onChange } = this.props;
    onChange(name, getTimestampFromString(value));
  }

  handleOpenChange(open) {
    if (open) {
      let { mode } = this.props;
      mode = mode || DateInput.DEFAULT_MODE;
      this.setState({ mode });
    }
  }

  handlePanelChange(val, mode) {
    this.setState({ mode });
    this.handleChange(val);
  }

  render() {
    const { className, value } = this.props;
    const { mode } = this.state;
    const momentValue = value ? moment(value) : undefined;
    return (
      <NormalizedInput>
        <DatePicker
          {...this.props}
          className={`Date ${className}`}
          onOpenChange={this.handleOpenChange}
          onPanelChange={this.handlePanelChange}
          onChange={this.handleChange} // the world changed here, is this bad?
          value={momentValue}
          mode={mode}
        />
      </NormalizedInput>
    );
  }
}

DateInput.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.number,
    PropTypes.instanceOf(moment),
  ]),
  format: PropTypes.string,
  dropdownClassName: PropTypes.string,
};

DateInput.defaultProps = {
  className: '',
  mode: undefined,
  dropdownClassName: '',
  value: null,
  format: 'MM/DD/YYYY',
};

export default DateInput;
